export default __webpack_public_path__ + "d0bc10648bf4886e67efc7a0f56376d2.png";